/**
 * Earning Schedule API Service
 * Handles API calls for earning type scheduling in admin portal
 * 
 * Base path: /api/account/sellers/earning-types
 */

import api from '../../redux/api';

const EARNING_TYPES_BASE = '/account/sellers/earning-types';

export const earningScheduleService = {
  /**
   * Schedule earning type change for a seller
   * POST /api/account/sellers/earning-types/schedule
   */
  scheduleChange: async ({ sellerId, newEarningType, effectiveDate, notifySeller = true, unlockProductsTab = true }) => {
    const response = await api.post(`${EARNING_TYPES_BASE}/schedule`, {
      seller_id: sellerId,
      new_value: newEarningType,
      effective_date: effectiveDate,
      notify_seller: notifySeller,
      unlock_products_tab: unlockProductsTab
    });
    return response.data;
  },

  /**
   * Get all scheduled changes
   * GET /api/account/sellers/earning-types/scheduled
   */
  getScheduledChanges: async () => {
    const response = await api.get(`${EARNING_TYPES_BASE}/scheduled`);
    return response.data;
  },

  /**
   * Modify scheduled effective date
   * PATCH /api/account/sellers/earning-types/scheduled/:seller_id
   */
  modifySchedule: async ({ sellerId, effectiveDate, reason }) => {
    const response = await api.patch(`${EARNING_TYPES_BASE}/scheduled/${sellerId}`, {
      effective_date: effectiveDate,
      reason
    });
    return response.data;
  },

  /**
   * Cancel scheduled change
   * DELETE /api/account/sellers/earning-types/scheduled/:seller_id
   */
  cancelSchedule: async ({ sellerId, reason }) => {
    const response = await api.delete(`${EARNING_TYPES_BASE}/scheduled/${sellerId}`, {
      data: { reason }
    });
    return response.data;
  },

  /**
   * Get seller setup status
   * GET /api/account/sellers/:seller_id/setup-status
   */
  getSetupStatus: async (sellerId) => {
    const response = await api.get(`${EARNING_TYPES_BASE}/${sellerId}/setup-status`);
    return response.data;
  },

  /**
   * Bulk schedule changes for multiple sellers
   * POST /api/account/sellers/earning-types/bulk-schedule
   */
  bulkSchedule: async ({ sellerIds, newEarningType, effectiveDate, notifySellers = true }) => {
    const response = await api.post(`${EARNING_TYPES_BASE}/bulk-schedule`, {
      sellers: sellerIds,
      new_value: newEarningType,
      effective_date: effectiveDate,
      notify_sellers: notifySellers
    });
    return response.data;
  },

  /**
   * Bulk cancel scheduled changes
   * POST /api/account/sellers/earning-types/bulk-cancel
   */
  bulkCancel: async ({ sellerIds, reason }) => {
    const response = await api.post(`${EARNING_TYPES_BASE}/bulk-cancel`, {
      seller_ids: sellerIds,
      reason
    });
    return response.data;
  },

  /**
   * Revert to Product-Based configuration (restore archived)
   * POST /api/account/sellers/:seller_id/revert-to-product-based
   */
  revertToProductBased: async ({ sellerId, force = false }) => {
    const response = await api.post(`${EARNING_TYPES_BASE}/${sellerId}/revert-to-product-based`, {
      force
    });
    return response.data;
  }
};

export default earningScheduleService;
